<template>
  <component v-if="component" v-bind:is="component"></component>
  <div v-else>
    <article v-if="loaded && !error">
      <div
          v-if="projectFeaturedImg"
          class="project-featured-img"
          :style="`background-image: url(${projectFeaturedImg});`">
        <div class="content pf-content">
          <h1 class="pf-title content">{{ projectName }}</h1>
        </div>
      </div>
      <h1 v-if="!projectFeaturedImg" class="content">{{ projectName }}</h1>
      <div class="content" v-html="projectContentConverted"></div>
    </article>
    <div v-else-if="error" class="content">
      <h1>Error</h1>
      {{ error }}
    </div>
    <div v-else class="loading"></div>
    <div v-if="!error" class="content">
      <h1>Featured Projects</h1>
      <ProjectsFeatured :size="2"/>
      <router-link to="/projects" class="float-right more-link">More &raquo;</router-link>
    </div>
  </div>
</template>

<script>
  import API from '../class/API';
  import ProjectsFeatured from '@/components/ProjectsFeatured';
  import Showdown from '../class/Showdown';
  import P404 from '../views/p404';

  export default {
    name: 'project',
    title() {
      return this.projectName ? this.projectName : 'Project';
    },
    data() {
      return {
        projectName: '',
        projectContent: '',
        projectFeaturedImg: null,
        loaded: false,
        error: null,
        component: null
      };
    },
    asyncData(route) {
      // Don't display the page until the async data has loaded.
      // Result does not need to be stored, as the cache function of the API will return the same promise when called in
      // the mounted method.
      return fetchPageData(route.route.params.urlPostFix);
    },
    computed: {
      projectContentConverted() {
        return Showdown.makeHtml(this.projectContent);
      }
    },
    components: { ProjectsFeatured },
    created() {
      fetchPageData(this.$route.params.urlPostFix)
          .then((data) => {
            this.component = null;
            this.error = null;
            this.loaded = true;
            this.projectName = data.name;
            this.projectContent = data.content;
            this.projectFeaturedImg = data.featuredImg;
          })
          .catch((error) => {
            this.error = 'Failed to load page, please try again.';
            console.log(error);

            // Display 404 page if project isn't found
            if (error.status === 404) {
              this.component = P404;
            }
          });
    },
    watch: {
      projectName: 'updateTitle' // Update the page title when the projectName variable changes.
    }
  };

  function fetchPageData(urlPostFix) {
    return API.request('GET', `project/get/${urlPostFix}`, [], true).send();
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables";
  .project-featured-img {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    height: 400px;

    .pf-content {
      position: relative;
      height: 100%;
    }

    .pf-title {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;

      font-weight: bold;

      text-shadow: 2px 2px 0 black;
    }
    @media screen and (min-width: $mediaNavigationMobile) {
       .pf-title {
         font-size: $h1FontSize * 1.5;
       }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Project.vue